/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactNode, useEffect, useState } from "react";

import { CartContext } from "@/contexts/cartContext";
import { cartService } from "@/services/cart";
import { Cart } from "@/types/cart";

export const CartContextProvider = ({
  isAuthenticated,
  children,
}: {
  isAuthenticated: boolean;
  children: ReactNode;
}) => {
  const [cart, setCart] = useState<Cart>();
  const [showCart, setShowCart] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refetchCounter, setRefetchCounter] = useState(0);

  useEffect(() => {
    async function getCartIfExists() {
      try {
        const latestActiveCart = await cartService.getLatestActiveCart();
        setCart(latestActiveCart);
      } catch (error) {
        console.error(error);
        setError("Error fetching cart");
      } finally {
        setLoading(false);
      }
    }

    if (isAuthenticated) {
      getCartIfExists();
    }
  }, [isAuthenticated, refetchCounter]);

  const refetchCart = () => {
    setRefetchCounter((prev) => prev + 1);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        showCart,
        setShowCart,
        loading,
        setLoading,
        error,
        refetchCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
